import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES, CONTACT } from "@/data/site";

const sections = [
  { h: "Acceptance of Terms", p: "By accessing and using this website, you agree to these Terms & Conditions. If you do not agree, please discontinue use of the website." },
  { h: "Use of Website", p: "This website is provided for general information about AutoMex Group's industrial infrastructure and technology capabilities. Content may be updated or revised at any time without notice." },
  { h: "No Guarantees", p: "Information on this website is provided in good faith for general guidance. Project scope, timelines and deliverables are defined only through a formal written agreement." },
  { h: "Intellectual Property", p: "All branding, text, graphics and content on this website are the property of AutoMex Group unless stated otherwise, and may not be reproduced without permission." },
  { h: "Enquiries", p: "Submitting an enquiry does not create a contractual obligation. Engagements are governed by separately agreed proposals and contracts." },
  { h: "Limitation of Liability", p: "AutoMex Group is not liable for any indirect or consequential loss arising from the use of this website or reliance on its general content." },
  { h: "Contact", p: `For questions about these terms, contact us at ${CONTACT.email} or ${CONTACT.phone}. AutoMex Group, ${CONTACT.location}.` },
];

export default function Terms() {
  useSeo({
    title: "Terms & Conditions | AutoMex Group",
    description: "Terms & Conditions governing the use of the AutoMex Group website.",
    path: "/terms",
  });
  return (
    <>
      <PageHero overline="Legal" title="Terms & Conditions" image={IMAGES.peb} crumb="Terms" />
      <section className="py-24 md:py-28 bg-white">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          {sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.03}>
              <div className="mb-10">
                <h2 className="font-heading text-2xl font-bold uppercase tracking-tight text-automex-ink">{s.h}</h2>
                <p className="mt-3 text-slate-600 leading-relaxed">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
